import React from 'react';
import styles from './index.module.scss';
import { textConstants } from '../../../constants';
import { Button } from '../Button';

const NoInternetConnection = () => {
  // Function to handle retry
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className={styles.noInternetContainer}>
      <svg 
        width="146" 
        height="231" 
        viewBox="0 0 146 231" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={styles.noInternetImg} // Added className for consistency
        aria-hidden="true" // Added for accessibility
      >
        <path d="M16.7754 205.5C40.2754 182.5 51.7754 111.5 72.2754 56.5C72.2754 56.5 112.775 197.5 128.275 207" stroke="#051B46"/>
        <circle cx="71.2754" cy="52" r="6" fill="#051B46" stroke="#051B46"/>
        <path d="M29.2754 187L100.275 146.297" stroke="#051B46"/>
        <path d="M116.775 188.5L44.2754 147" stroke="#051B46"/>
        <path d="M38.7754 164L95.2754 131" stroke="#051B46"/>
        <path d="M45.7754 142.5L90.2754 114.5" stroke="#051B46"/>
        <path d="M52.2754 120.5L85.7754 100.5" stroke="#051B46"/>
        <path d="M58.2754 99L80.7754 84M64.2754 80L76.7754 71.5M61.7754 86.5L85.2754 100M57.7754 102L92.7754 122.5M53.2754 116L100.275 146M48.7754 131.5L108.275 167" stroke="#051B46"/>
        <path d="M67.2764 70.5L79.2764 80" stroke="#051B46"/>
        <path d="M90.2764 33.5C103.276 46.5 102.776 60.5 91.2764 72M104.776 89.5C121.776 72 124.276 57.5 116.276 33.5M104.776 17C108.276 19 110.276 21.5 111.276 25.5M121.776 0.5C149.776 32 152.276 72 121.776 105.5" stroke="#051B46"/>
        <path d="M54.7227 34C41.7227 47 42.2227 61 53.7227 72.5M40.2227 90C23.2227 72.5 20.7227 58 28.7227 34M40.2227 17.5C36.7227 19.5 34.7227 22 33.7227 26M23.2227 1C-4.77734 32.5 -7.27734 72.5 23.2227 106" stroke="#051B46"/>
        <g opacity="0.8" filter="url(#filter0_f_8919_21540)">
          <path d="M139.122 169.935L19.2769 203.881" stroke="url(#paint0_linear_8919_21540)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <g opacity="0.8" filter="url(#filter1_f_8919_21540)">
          <path d="M129.276 177L128.276 204.441" stroke="url(#paint1_linear_8919_21540)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
          <filter id="filter0_f_8919_21540" x="12.5269" y="163.185" width="133.345" height="47.4463" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_8919_21540"/>
          </filter>
          <filter id="filter1_f_8919_21540" x="121.526" y="170.25" width="14.5" height="40.9404" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_8919_21540"/>
          </filter>
          <linearGradient id="paint0_linear_8919_21540" x1="124.464" y1="170.545" x2="19.277" y2="204.5" gradientUnits="userSpaceOnUse">
            <stop stopColor="#051B46" stopOpacity="0"/>
            <stop offset="1" stopColor="#051B46"/>
          </linearGradient>
          <linearGradient id="paint1_linear_8919_21540" x1="126.345" y1="178.479" x2="115.391" y2="182.606" gradientUnits="userSpaceOnUse">
            <stop stopColor="#051B46" stopOpacity="0"/>
            <stop offset="1" stopColor="#051B46"/>
          </linearGradient>
        </defs>
      </svg>

      <div className={styles.textBold}>{textConstants.noInternet}</div>
      <div className={styles.text}>{textConstants.notWorkingText}</div>
      <div className={styles.buttonContainer}>
        <Button
          onClick={handleRetry}
          buttonTextClassName={styles.retryButton}
          datatestid="retry-connection-button"
          datatestidText={textConstants.retryText}
        >
          {textConstants.retryText}
        </Button>
      </div>
    </div>
  );
};

export default NoInternetConnection;